import React from "react"
import "./Services.css";
import Cards from "../Card/Card";

const Services=()=>{
    return(
<>
<div className="services" id='services'>
<div className="a-heading">

              <h1 className="display-2">
              Meet Our Teachers <br /> 
              </h1>
              </div>

<div className="s-subheading"><p>
    Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem
     praesentium nostrum doloribus, aut nobis iusto. Omnis quam rem aliquid, <br></br>
     molestias blanditiis fuga quisquam 
   voluptas dignissimos animi voluptate velit eos distinctio.
    </p>
    </div>
    <div className="s-center">
        <Cards/>
    </div>
    </div>
</>
    )
}
export default Services;
